import { fg } from '@atlaskit/platform-feature-flags';

import { ApplicationModes } from '../../common/constants/application-modes';

export const areLLMPoweredFeaturesEnabled = (
	appMode: ApplicationModes,
	isAdminHubAIEnabled: boolean,
	isRovoLLMEnabled: boolean,
): boolean => {
	// TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
	if (appMode === ApplicationModes.Unified) {
		return isAdminHubAIEnabled;
	}

	if (fg('rovo_search_updated_entitlement_checks_for_team_25')) {
		return isRovoLLMEnabled;
	}

	return true;
};
